(ns ui.editor2.sidebar-background
  (:require [ui.editor2.common :as common]))

(defn entry
  [selected?]
  [:div
   {:class ["flex" "pt-3" "pb-3" "pl-2" "pr-2" "flex-col" "justify-center" "items-center" "gap-1" "rounded-lg" "cursor-pointer" "hover:bg-gray-600"
            (when selected?
              "bg-gray-800")]
    :on {:click [[:store/assoc-in [:editor2 :sidebar-panel] :background]]}}
   [:svg
    {:xmlns "http://www.w3.org/2000/svg",
     :fill "none",
     :viewBox "0 0 24 24",
     :stroke-width "1.5",
     :stroke "currentColor",
     :class ["size-6" (when-not selected? "text-slate-400")]}
    [:path
     {:stroke-linecap "round",
      :stroke-linejoin "round",
      :d
      "m15 11.25 1.5 1.5.75-.75V8.758l2.276-.61a3 3 0 1 0-3.675-3.675l-.61 2.277H12l-.75.75 1.5 1.5M15 11.25l-8.47 8.47c-.34.34-.8.53-1.28.53s-.94.19-1.28.53l-.97.97-.75-.75.97-.97c.34-.34.53-.8.53-1.28s.19-.94.53-1.28L12.75 9M15 11.25 12.75 9"}]]
   [:span
    {:class ["text-center" "text-xs" "font-medium" (when-not selected? "text-slate-400")]}
    "Background"]])

(defn panel
  [state]
  (let [slide (common/get-current-slide state)
        background-color (or (:slide/background-color slide)
                             "#000000")]
    ;; panel-grid-list
    [:div
     {:class ["flex" "flex-col" "gap-2" "w-full"]}
     [:div
      [:div
       [:label.block.font-medium
        "Background Color"]
       [:div.mt-2
        [:input
         {:type "color"
          :on {:input [[:editor2/set-background-color :event/target.value]]}
          :value background-color
          :class ["block"
                  "bg-white"
                  "px-1"
                  "outline"
                  "outline-1"
                  "outline-offset-1"
                  "outline-gray-300"
                  "placeholder:text-gray-400"
                  "focus:outline"
                  "focus:outline-2"
                  "focus:-outline-offset-2"
                  "focus:outline-indigo-600"
                  "sm:text-sm/6"]}]]]]
     ]))
